// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-logo-text {
  font-size: 48px;
}

.menu-logo-text-loggedin {
  font-size: 32px;
}

.user-name {
  font-size: 0.75rem;
  line-height: 20px;
  vertical-align: text-top;
}

.side-nav {
  background-color: #0d181c !important;
}

.dropdown-line {
  border-top: 1px solid #ddd;
}

#vehicle-search {
  cursor: pointer;
}
#vehicle-search:hover {
  color: rgba(0, 0, 0, 0.3);
}

a.dropdown-item, a.dropdown-item:visited {
  color: var(--textColour);
}

.search-submit {
  border: 0 solid transparent !important;
  cursor: pointer;
  color: var(--floatLabelColour) !important;
}

nav {
  background-color: var(--navbarBgColour) !important;
}
nav .login-link .nav-link, nav .signup-link .nav-link {
  font-weight: 600 !important;
}

nav .nav-link, nav {
  color: var(--navbarTextColour) !important;
  font-size: 16px;
  font-weight: 500;
}
nav .nav-link:hover, nav:hover {
  color: var(--navbarTextHoverColour);
}

.navbar {
  padding-top: 0.5rem;
  min-height: var(--headerHeight);
}

nav .nav-link:hover, .navbar-light .navbar-nav .show > .nav-link, nav {
  color: var(--navbarTextHoverColour);
}

.navbar-nav.inline {
  flex-direction: row !important;
}

nav .navbar-brand, nav .navbar-brand a, .navbar-brand a:visited {
  font-weight: bold;
  color: var(--navbarBrandColour) !important;
  cursor: pointer;
}

nav .navbar-brand a {
  color: inherit;
  text-decoration: inherit;
}

.navbar-light .navbar-toggler {
  color: var(--navbarTextHoverColour);
  padding-bottom: 0 !important;
  border: 0;
}
.navbar-light .navbar-toggler .toggler-text {
  font-size: 1rem;
  font-weight: bold;
  vertical-align: top;
  line-height: 1.2rem;
  padding-right: 5px;
  display: inline-block;
}

.search-container {
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
}

nav .nav-link.menu-buttons {
  padding-left: 15px;
  padding-right: 15px;
}
nav .nav-link.btn-tertiary.sign-up {
  color: #fff !important;
}
nav .nav-link.btn-tertiary.sign-up:hover {
  background-color: #444 !important;
}
nav .nav-link.btn-tertiary-outline.login {
  font-weight: 500 !important;
}

.search-box {
  max-width: 650px;
}
.search-box .search-text-input {
  background-color: var(--navSearchBgColour);
  color: var(--navSearchTextColour) !important;
  border: 0 !important;
  font-size: 0.85rem;
  font-weight: 500;
}
.search-box .search-text-input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--colour10);
  opacity: 1; /* Firefox */
  font-weight: 400 !important;
}
.search-box .search-text-input:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: var(--colour10);
  font-weight: 400 !important;
}
.search-box .search-text-input::-ms-input-placeholder { /* Microsoft Edge */
  color: var(--colour10);
  font-weight: 400 !important;
}

:focus {
  outline-width: 0 !important;
}

.user-dropdown {
  font-size: 0.9rem;
  font-weight: 500;
}
.user-dropdown .fa-user {
  color: var(--topbarIconColour) !important;
}
.user-dropdown span {
  color: var(--linkColour);
}

.contact-message {
  display: inline-block;
  width: 32px;
  height: 32px;
}

.search-link .fa-search {
  font-size: 25px;
  vertical-align: middle;
  margin-left: -4px;
  color: var(--topbarIconColour);
}

.email-link {
  white-space: nowrap;
  padding: 0.4rem;
}
.email-link .fa-envelope {
  font-size: 25px;
  vertical-align: middle;
  margin-left: -4px;
  color: var(--topbarIconColour);
}
.email-link .email-count {
  display: inline-block;
  position: relative;
  background-color: var(--errorColour);
  color: var(--colour3);
  padding: 0px 8px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  vertical-align: middle;
  min-width: 24px;
  min-height: 24px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/common/app-topbar/app-topbar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,wBAAA;AACF;;AAEA;EAEE,oCAAA;AAAF;;AAIA;EAEE,0BAAA;AAFF;;AAMA;EACE,eAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;;AAQA;EAEE,wBAAA;AANF;;AAUA;EACE,sCAAA;EACA,eAAA;EACA,yCAAA;AAPF;;AAWA;EACE,kDAAA;AARF;AAWI;EACE,2BAAA;AATN;;AAcA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;AAXF;AAaE;EACE,mCAAA;AAXJ;;AAgBA;EACE,mBAAA;EACA,+BAAA;AAbF;;AAgBA;EACE,mCAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,0CAAA;EACA,eAAA;AAbF;;AAgBA;EACE,cAAA;EACA,wBAAA;AAbF;;AAgBA;EAEE,mCAAA;EAYA,4BAAA;EACA,SAAA;AAzBF;AAcE;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAbJ;;AAoBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAjBF;;AAqBE;EACE,kBAAA;EACA,mBAAA;AAlBJ;AAoBE;EACE,sBAAA;AAlBJ;AAmBI;EACE,iCAAA;AAjBN;AAqBE;EACE,2BAAA;AAnBJ;;AAuBA;EAEE,gBAAA;AArBF;AAuBE;EAEE,0CAAA;EACA,4CAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAtBJ;AAwBI,8CAAA,yCAAA;EACE,sBAAA;EACA,UAAA,EAAA,YAAA;EACA,2BAAA;AAtBN;AAyBI,uDAAA,4BAAA;EACE,sBAAA;EACA,2BAAA;AAvBN;AA0BI,wDAAA,mBAAA;EACE,sBAAA;EACA,2BAAA;AAxBN;;AA6BA;EACE,2BAAA;AA1BF;;AA8BA;EAME,iBAAA;EACA,gBAAA;AAhCF;AA2BE;EACE,yCAAA;AAzBJ;AA+BE;EACE,wBAAA;AA7BJ;;AAiCA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAmCE;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;AAhCJ;;AAoCA;EAEE,mBAAA;EACA,eAAA;AAlCF;AAoCE;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;AAlCJ;AAqCE;EACE,qBAAA;EACA,kBAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAnCJ","sourcesContent":[".menu-logo-text {\n  font-size: 48px;\n}\n\n.menu-logo-text-loggedin {\n  font-size: 32px;\n}\n\n.user-name {\n  font-size: 0.75rem;\n  line-height: 20px;\n  vertical-align: text-top;\n}\n\n.side-nav {\n\n  background-color: #0d181c !important;\n\n}\n\n.dropdown-line {\n\n  border-top: 1px solid #ddd;\n\n}\n\n#vehicle-search {\n  cursor: pointer;\n\n  &:hover {\n    color: rgba(0, 0, 0, 0.3);\n  }\n}\n\n\na.dropdown-item, a.dropdown-item:visited {\n\n  color: var(--textColour);\n\n}\n\n.search-submit {\n  border: 0 solid transparent !important;\n  cursor: pointer;\n  color: var(--floatLabelColour) !important;\n}\n\n\nnav {\n  background-color: var(--navbarBgColour) !important;\n\n  .login-link, .signup-link {\n    .nav-link {\n      font-weight: 600 !important;\n    }\n  }\n}\n\nnav .nav-link, nav {\n  color: var(--navbarTextColour) !important;\n  font-size: 16px;\n  font-weight: 500;\n\n  &:hover {\n    color: var(--navbarTextHoverColour);\n  }\n\n}\n\n.navbar {\n  padding-top: 0.5rem;\n  min-height: var(--headerHeight);\n}\n\nnav .nav-link:hover, .navbar-light .navbar-nav .show > .nav-link, nav {\n  color: var(--navbarTextHoverColour);\n}\n\n.navbar-nav.inline {\n  flex-direction: row !important;\n}\n\nnav .navbar-brand, nav .navbar-brand a, .navbar-brand a:visited {\n  font-weight: bold;\n  color: var(--navbarBrandColour) !important;\n  cursor: pointer;\n}\n\nnav .navbar-brand a {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n.navbar-light .navbar-toggler {\n\n  color: var(--navbarTextHoverColour);\n\n  .toggler-text {\n\n    font-size: 1rem;\n    font-weight: bold;\n    vertical-align: top;\n    line-height: 1.2rem;\n    padding-right: 5px;\n    display: inline-block;\n  }\n\n  padding-bottom: 0 !important;\n  border: 0;\n}\n\n.search-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n}\n\nnav {\n  .nav-link.menu-buttons {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .nav-link.btn-tertiary.sign-up {\n    color: #fff !important;\n    &:hover {\n      background-color: #444 !important;\n    }\n  }\n\n  .nav-link.btn-tertiary-outline.login {\n    font-weight: 500 !important;\n  }\n}\n\n.search-box {\n\n  max-width: 650px;\n\n  .search-text-input {\n\n    background-color: var(--navSearchBgColour);\n    color: var(--navSearchTextColour) !important;\n    border: 0 !important;\n    font-size: 0.85rem;\n    font-weight: 500;\n\n    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n      color: var(--colour10);\n      opacity: 1; /* Firefox */\n      font-weight: 400 !important;\n    }\n\n    &:-ms-input-placeholder { /* Internet Explorer 10-11 */\n      color: var(--colour10);\n      font-weight: 400 !important;\n    }\n\n    &::-ms-input-placeholder { /* Microsoft Edge */\n      color: var(--colour10);\n      font-weight: 400 !important;\n    }\n  }\n}\n\n:focus {\n  outline-width: 0 !important;\n}\n\n\n.user-dropdown {\n\n  .fa-user {\n    color: var(--topbarIconColour) !important;\n  }\n\n  font-size: 0.9rem;\n  font-weight: 500;\n\n  span {\n    color: var(--linkColour);\n  }\n}\n\n.contact-message {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n}\n\n.search-link {\n\n  .fa-search {\n    font-size: 25px;\n    vertical-align: middle;\n    margin-left: -4px;\n    color: var(--topbarIconColour);\n  }\n}\n\n.email-link {\n\n  white-space: nowrap;\n  padding: 0.4rem;\n\n  .fa-envelope {\n    font-size: 25px;\n    vertical-align: middle;\n    margin-left: -4px;\n    color: var(--topbarIconColour);\n  }\n\n  .email-count {\n    display: inline-block;\n    position: relative;\n    background-color: var(--errorColour);\n    color: var(--colour3);\n    padding: 0px 8px;\n    font-size: 16px;\n    font-weight: bold;\n    border-radius: 12px;\n    vertical-align: middle;\n    min-width: 24px;\n    min-height: 24px;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
